const arraysAreShallowEqual = (arrA, arrB) => {
  if (arrA === arrB) {
    return true
  }

  const len = arrA.length

  if (arrB.length !== len) {
    return false
  }

  for (var i = 0; i < len; i++) {
    if (arrA[i] !== arrB[i]) {
      return false
    }
  }

  return true
}

export default arraysAreShallowEqual



// WEBPACK FOOTER //
// ./src/utility/arraysAreShallowEqual.js